// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__HlRWn","card":"ErrorPage_card__54p3R","message":"ErrorPage_message__xKlF2","homeLink":"ErrorPage_homeLink__tdToL"};